import { Layout } from './layout';

Layout.displayName = 'LargeTitle';

export { Layout as LargeTitle };

export type { Props as LargeTitleProps } from './types';
